import { render, staticRenderFns } from "./CreatedCard.vue?vue&type=template&id=31691fe8&scoped=true&"
import script from "./CreatedCard.vue?vue&type=script&lang=js&"
export * from "./CreatedCard.vue?vue&type=script&lang=js&"
import style0 from "./CreatedCard.vue?vue&type=style&index=0&id=31691fe8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31691fe8",
  null
  
)

export default component.exports